var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M140.104 4.98c0-1.79-.808-2.553-2.703-2.553h-17.196V7.6h17.196c1.87 0 2.703-.845 2.703-2.62zm3.896 0c0 2.607-2.324 4.067-4.51 4.067h-22.97V.98h22.97c2.186 0 4.51 1.402 4.51 4zM74.791 2.427h20.881V.98H72.703c-2.187 0-4.51 1.402-4.51 4 0 2.608 2.323 4.068 4.51 4.068h22.969V7.6h-20.88c-1.87 0-2.704-.845-2.704-2.62 0-1.79.808-2.553 2.703-2.553zM6.161 7.581c-1.713 0-2.476-.725-2.476-2.351V.958H0V5.23c0 2.467 2.2 3.8 4.271 3.8h22.332V7.58H6.16zM56.98.98v6.624H39.568c-1.712 0-2.475-.725-2.475-2.352V.98h-3.685v4.272c0 2.468 2.2 3.8 4.271 3.8h22.987V.979h-3.685zm47.326 8.252h3.578V.769h-3.578v8.462z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8d1a1b7bf87147d37cee4b4c7fd14c7.svg";
export { ForwardRef as ReactComponent };